import { render, staticRenderFns } from "./cardList.vue?vue&type=template&id=5138def6&scoped=true&"
import script from "./cardList.vue?vue&type=script&lang=ts&"
export * from "./cardList.vue?vue&type=script&lang=ts&"
import style0 from "./cardList.vue?vue&type=style&index=0&id=5138def6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5138def6",
  null
  
)

export default component.exports